import { webRequestClient } from '@/services'
import { errorHandler } from '@/utils/helpers'

const actions = {
    retrieveInterfaceMessages({ commit }) {
        return webRequestClient
            .get('/audience_admin/interface_messages.json')
            .then(messages => {
                commit('setInterfaceMessages', { list: messages.list })
            })
            .catch(error => {
                errorHandler(error, commit)
            })
    }
}

export default actions
